import React from "react";

// Reusable section wrapper for consistent spacing, width, and background variants
// Variants: light, alt, dark, gradient, subtle
const variantClasses = {
  light: "bg-white dark:bg-[#0d1625]",
  alt: "bg-[#f9fafb] dark:bg-[#121e2e]",
  dark: "bg-[#0b1220] text-white",
  gradient:
    "relative bg-gradient-to-b from-white via-white to-gray-50 dark:from-[#0d1625] dark:via-[#0d1625] dark:to-[#121e2e]",
  subtle: "relative bg-white dark:bg-[#0d1625]",
};

const SectionContainer = ({
  id,
  children,
  className = "",
  variant = "light",
}) => {
  return (
    <section
      id={id}
      className={`section-wrapper py-24 ${
        variantClasses[variant] || variantClasses.light
      } ${className}`}
    >
      {/* Decorative overlays for gradient/subtle variants */}
      {variant === "gradient" && (
        <div className="absolute inset-0 pointer-events-none [mask-image:radial-gradient(circle_at_center,white,transparent)] opacity-60"></div>
      )}
      {variant === "subtle" && (
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-[#E5C558]/5 to-transparent"></div>
      )}
      <div className="relative max-w-7xl mx-auto px-4">{children}</div>
    </section>
  );
};

export default SectionContainer;
